import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tbdc-environment"
}
const _hoisted_2 = {
  style: {"background-color":"#0099D5","height":"72px"},
  class: "ml-1"
}
const _hoisted_3 = {
  href: "https://www.thebigdatacompany.nl",
  target: "_blank"
}
const _hoisted_4 = { style: {"position":"fixed","left":"50%","top":"50%","transform":"translate(-50%,-50%)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_BusyLogo = _resolveComponent("BusyLogo")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_Error = _resolveComponent("Error")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      (_ctx.environment != 'Production' && _ctx.environment != 'Demo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.environment), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_app_bar, {
        class: "d-print-none tbdc-elevation-5",
        height: "72"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, {
            name: "topLeftMenu",
            onDisableMenu: _ctx.updateStatus
          }, null, 8, ["onDisableMenu"]),
          _createVNode(_component_router_view, { name: "modelLogo" }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_router_view, { name: "modelMenu" }),
          _createVNode(_component_router_view, { name: "loginMenu" }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
              _createVNode(_component_BusyLogo, {
                class: "mx-5",
                style: {"margin-top":"17px"},
                active: _ctx.error == null && (_ctx.inProgress > 0 || _ctx.busy > 0 || _ctx.databaseStatus == 1)
              }, null, 8, ["active"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_view),
      _createVNode(_component_v_overlay, {
        "model-value": _ctx.error == null && _ctx.busy > 0,
        class: "tbdc-overlay"
      }, null, 8, ["model-value"]),
      _createVNode(_component_v_overlay, {
        "model-value": _ctx.error == null && _ctx.databaseStatus == 1,
        style: {"z-index":"250"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_img, {
              "max-width": "600",
              src: require('./assets/loading.png')
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createVNode(_component_Error, { class: "d-print-none" }),
      _createVNode(_component_ConfirmDialog)
    ]),
    _: 1
  }))
}